import React from 'react';
import ListItem from 'components/ListItem';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { EquipmentSetName } from 'services/equipmentSets/types';
import { makeSelectEquipmentSetField } from 'services/equipmentSets/selectors';

export interface OwnProps {
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    equipmentSetName: EquipmentSetName;
}

type Props = OwnProps & ConnectedProps;

export class SummaryEquipmentSetNameListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { equipmentSetName } = this.props;

        return (
            <ListItem
                description="Set"
                value={equipmentSetName}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    equipmentSetName: makeSelectEquipmentSetField('name')
});

export default connect(mapStateToProps)(
    SummaryEquipmentSetNameListItemComponent
);
